import "phoenix_html"
import renderReactElements from "./util/renderReactElements"
import { configure } from "mobx"
configure({ enforceActions: "never" })

import "./components/*.(t|j)sx"
import "./components/wizard"

import CardForm from "./third_party/CardForm"
import setupIntentForm from "./third_party/setupIntentForm"
import tenantBankAccountSetupIntentForm from "./third_party/tenantBankAccountSetupIntentForm"
import oneTimePaymentIntentForm from "./third_party/oneTimePaymentIntentForm"
import paymentProcessingElement from "./third_party/paymentProcessingElement"
import BulkCreditRecipientForm from "./legacy_components/BulkCreditRecipientForm"
import { ParticipationPaymentBreakdownFormInputs } from "./legacy_components/ParticipationPaymentBreakdownFormInputs"
import AdminPaymentSourceInputs from "./legacy_components/admin/AdminPaymentSourceInputs"
import InfoTooltip from "./legacy_components/shared/InfoTooltip"
import { addressFormToggles } from "./addresses"
import dateFormatter from "./dateFormatter"
import ListEditor from "./legacy_components/ListEditor"
import Alpine from "alpinejs"
import Clipboard from "@ryangjchandler/alpine-clipboard"
import "./element-toggle.js"
import "./third_party/quill"
import { Socket } from "phoenix"
import { LiveSocket } from "phoenix_live_view"
import { Hooks as designSystemHooks, attachListeners } from "../../deps/design_system/priv/assets/design_system"

import disable from "./disable"
import disableLinkOnClick from "./disableLinkOnClick.js"
import autosubmit from "./autosubmit"
import apiNotices from "./apiNotices"

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")

let liveSocket = new LiveSocket("/live", Socket, {
  hooks: { ...designSystemHooks },
  longPollFallbackMs: 2500,
  params: { _csrf_token: csrfToken },
})

// connect if there are any LiveViews on the page
liveSocket.connect()
window.liveSocket = liveSocket
attachListeners()

CardForm()

setupIntentForm()
tenantBankAccountSetupIntentForm()
oneTimePaymentIntentForm()
paymentProcessingElement()
renderReactElements(InfoTooltip, "react-info-tooltip")
renderReactElements(BulkCreditRecipientForm, "react-bulk-credit-recipient-form")
renderReactElements(ParticipationPaymentBreakdownFormInputs, "react-participation-payment-breakdown-inputs")
renderReactElements(AdminPaymentSourceInputs, "react-admin-payment-source-inputs")
renderReactElements(ListEditor, "react-list-editor")

disable()
disableLinkOnClick()
autosubmit()
apiNotices()
addressFormToggles()
dateFormatter()

import loadSvelteComponents from "./loadSvelteComponents"
import { webifySvelte } from "./util/webify"

loadSvelteComponents({
  AdjustmentForm: require("./components/AdjustmentForm.svelte"),
  TripQuestionnaireForm: require("./components/TripQuestionnaireForm.svelte"),
  CancellationForm: require("./components/CancellationForm.svelte"),
  RefundForm: require("./components/RefundForm.svelte"),
  StaffPermissionEditor: require("./components/StaffPermissionEditor.svelte"),
  MilestoneEditor: require("./components/MilestoneEditor.svelte"),
  TripPackagesList: require("./components/TripPackagesList.svelte"),
  TripQuestionsList: require("./components/TripQuestionsList.svelte"),
})

webifySvelte("gc-notice", require("./components/Notice.svelte"))
webifySvelte("gc-hamburger-button", require("./components/HamburgerButton.svelte"))
webifySvelte("trip-registrations-editor", require("./components/TripRegistrationsEditor.svelte"))

Alpine.plugin(Clipboard)
window.Alpine = Alpine
Alpine.start()
